export default __webpack_public_path__ + "static/media/mintsite_graphic_3.2b84ad28.png";